import * as React from 'react'

function ConvertionReportSVG(props) {
  return (
    <svg width={300} height={188} viewBox="0 0 300 188" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <g filter="url(#filter0_d_1161_6599)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M68 114.578c0-5.799 4.701-10.5 10.5-10.5h115.614c5.799 0 10.5 4.701 10.5 10.5v40.843c0 5.798-4.701 10.499-10.5 10.499H78.5c-5.799 0-10.5-4.701-10.5-10.5v-40.842z"
          fill="#E3F2FC"
        />
      </g>
      <path
        opacity={0.3}
        fillRule="evenodd"
        clipRule="evenodd"
        d="M79.828 121.453a2.65 2.65 0 012.65-2.65h88.142a2.65 2.65 0 010 5.301H82.478a2.65 2.65 0 01-2.65-2.651z"
        fill="#1B3554"
      />
      <rect opacity={0.3} x={79.8281} y={129.404} width={66.8286} height={5.30078} rx={2.65039} fill="#1B3554" />
      <path
        opacity={0.15}
        fillRule="evenodd"
        clipRule="evenodd"
        d="M79.828 148.545a2.65 2.65 0 012.65-2.65H99.06a2.65 2.65 0 110 5.3H82.478a2.65 2.65 0 01-2.65-2.65z"
        fill="#1B3554"
      />
      <ellipse opacity={0.3} cx={180.367} cy={141.773} rx={12.4195} ry={12.3685} fill="#1B3554" />
      <g filter="url(#filter1_dd_1161_6599)">
        <circle cx={228.614} cy={135} r={16} fill="#E3F2FC" />
      </g>
      <g clipPath="url(#clip0_1161_6599)">
        <path
          d="M240.156 137.456l-1.005.762-1.003-.698c0-.073 0-.151-.004-.229 0-.073 0-.151-.005-.229-.064-1.806-.522-3.74-1.439-5.156-.706-1.087-1.609-1.605-2.617-1.605-1.059 0-1.92.633-2.874 2.008-.027.041-.059.082-.087.128-.018.023-.032.046-.05.074a7.665 7.665 0 00-.138.21 48.845 48.845 0 00-1.311 2.214c-.041.078-.087.156-.128.234a.422.422 0 00-.037.06l-.096.169-.568 1.004c-1.334 2.36-1.673 2.901-2.338 3.786-1.168 1.553-2.168 2.145-3.483 2.145-1.558 0-2.548-.674-3.158-1.692-.5-.825-.742-1.911-.742-3.148l2.277.078c0 .806.175 1.42.408 1.796.303.486.747.674 1.21.674.592 0 1.142-.124 2.187-1.572.838-1.16 1.828-2.782 2.493-3.804l.628-.958.133-.211.137-.206.229-.353a32.978 32.978 0 011.27-1.829c.046-.064.096-.128.142-.188.413-.527.848-1.017 1.316-1.421.847-.738 1.76-1.145 2.681-1.145 1.544 0 3.016.893 4.143 2.571 1.151 1.714 1.751 3.85 1.82 6.073.004.073.004.151.004.229a3.5 3.5 0 01.005.229z"
          fill="#0081FB"
        />
        <path
          d="M220.868 131.083c1.044-1.606 2.551-2.729 4.279-2.729 1.001 0 1.996.295 3.035 1.142 1.136.926 2.347 2.45 3.858 4.963l.542.902c1.308 2.175 2.052 3.294 2.488 3.822.56.677.91.858 1.419.858 1.293 0 1.658-1.164 1.658-2.521l2.009-.063c0 1.418-.28 2.461-.757 3.284-.46.796-1.357 1.592-2.867 1.592-.939 0-1.77-.204-2.69-1.07-.706-.664-1.533-1.845-2.168-2.906l-1.891-3.153c-.949-1.582-1.82-2.762-2.323-3.296-.542-.575-1.211-1.262-2.323-1.262-.899 0-1.69.624-2.33 1.588l-1.939-1.151z"
          fill="url(#paint0_linear_1161_6599)"
        />
        <path
          d="M225.145 130.645c-.897 0-1.688.624-2.326 1.588-.902 1.362-1.455 3.391-1.455 5.339 0 .804-.001 1.408.229 1.782l-1.76 1.289c-.497-.828-.76-1.885-.76-3.123 0-2.25.621-4.625 1.795-6.437 1.043-1.606 2.562-2.729 4.287-2.729l-.01 2.291z"
          fill="url(#paint1_linear_1161_6599)"
        />
        <path
          opacity={0.05}
          d="M228.546 133.29l-.137.206-.133.211c.325.472.697 1.04 1.086 1.691l.096-.17a.477.477 0 01.037-.059c.041-.078.087-.156.128-.234a29.445 29.445 0 00-1.077-1.645zm1.499-2.182c-.05.064-.096.128-.142.192.335.417.674.89 1.031 1.421.046-.073.092-.142.138-.211.018-.027.032-.05.05-.073.028-.046.06-.087.087-.128a19.813 19.813 0 00-1.022-1.389c-.046.06-.096.124-.142.188z"
          fill="#000"
        />
        <path
          opacity={0.07}
          d="M228.546 133.291l-.137.206c.325.468.692 1.027 1.086 1.673.041-.078.087-.156.129-.234a30.379 30.379 0 00-1.078-1.645zm1.357-1.989c.335.417.674.889 1.031 1.421.046-.074.092-.142.138-.211-.353-.523-.697-.99-1.027-1.403-.05.065-.096.129-.142.193z"
          fill="#000"
        />
      </g>
      <g filter="url(#filter2_d_1161_6599)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M55 30.648c0-5.799 4.701-10.5 10.5-10.5h115.614c5.799 0 10.5 4.701 10.5 10.5v40.843c0 5.799-4.701 10.5-10.5 10.5H65.5c-5.799 0-10.5-4.701-10.5-10.5V30.648z"
          fill="#fff"
        />
      </g>
      <path
        opacity={0.3}
        fillRule="evenodd"
        clipRule="evenodd"
        d="M66.828 37.523a2.65 2.65 0 012.65-2.65h88.142a2.65 2.65 0 010 5.3H69.478a2.65 2.65 0 01-2.65-2.65z"
        fill="#1B3554"
      />
      <rect opacity={0.3} x={66.8281} y={45.4746} width={66.8286} height={5.30078} rx={2.65039} fill="#1B3554" />
      <path
        opacity={0.15}
        fillRule="evenodd"
        clipRule="evenodd"
        d="M66.828 64.615a2.65 2.65 0 012.65-2.65H86.06a2.65 2.65 0 010 5.3H69.478a2.65 2.65 0 01-2.65-2.65z"
        fill="#1B3554"
      />
      <ellipse opacity={0.3} cx={167.367} cy={57.8431} rx={12.4195} ry={12.3685} fill="#1B3554" />
      <g filter="url(#filter3_dd_1161_6599)">
        <circle cx={215.614} cy={51.0703} r={16} fill="#fff" />
      </g>
      <g clipPath="url(#clip1_1161_6599)">
        <path
          d="M227.156 53.526l-1.005.762-1.003-.697c0-.074 0-.152-.004-.23 0-.073 0-.15-.005-.229-.064-1.806-.522-3.74-1.439-5.156-.706-1.086-1.609-1.604-2.617-1.604-1.059 0-1.92.632-2.874 2.007-.027.041-.059.083-.087.129-.018.023-.032.045-.05.073-.046.069-.092.137-.138.21a48.665 48.665 0 00-1.311 2.215c-.041.077-.087.155-.128.233a.49.49 0 00-.037.06l-.096.17-.568 1.003c-1.334 2.36-1.673 2.901-2.338 3.786-1.168 1.554-2.168 2.145-3.483 2.145-1.558 0-2.548-.674-3.158-1.691-.5-.825-.742-1.912-.742-3.149l2.277.078c0 .807.175 1.42.408 1.797.303.485.747.673 1.21.673.592 0 1.142-.123 2.187-1.572.838-1.16 1.828-2.782 2.493-3.804l.628-.958.133-.21.137-.207.229-.353a33.507 33.507 0 011.27-1.829c.046-.064.096-.128.142-.188.413-.527.848-1.017 1.316-1.42.847-.738 1.76-1.146 2.681-1.146 1.544 0 3.016.894 4.143 2.571 1.151 1.714 1.751 3.85 1.82 6.073.004.073.004.151.004.23.005.077.005.15.005.228z"
          fill="#0081FB"
        />
        <path
          d="M207.868 47.154c1.044-1.607 2.551-2.73 4.279-2.73 1.001 0 1.996.295 3.035 1.142 1.136.926 2.347 2.45 3.858 4.963l.542.902c1.308 2.175 2.052 3.294 2.488 3.822.56.678.91.858 1.419.858 1.293 0 1.658-1.164 1.658-2.521l2.009-.063c0 1.419-.28 2.461-.757 3.284-.46.796-1.357 1.592-2.867 1.592-.939 0-1.77-.203-2.69-1.07-.706-.664-1.533-1.844-2.168-2.906l-1.891-3.152c-.949-1.583-1.82-2.763-2.323-3.297-.542-.575-1.211-1.262-2.323-1.262-.899 0-1.69.624-2.33 1.588l-1.939-1.15z"
          fill="url(#paint2_linear_1161_6599)"
        />
        <path
          d="M212.145 46.715c-.897 0-1.688.625-2.326 1.589-.902 1.362-1.455 3.39-1.455 5.339 0 .803-.001 1.408.229 1.78l-1.76 1.29c-.497-.828-.76-1.885-.76-3.123 0-2.25.621-4.625 1.795-6.436 1.043-1.607 2.562-2.73 4.287-2.73l-.01 2.291z"
          fill="url(#paint3_linear_1161_6599)"
        />
        <path
          opacity={0.05}
          d="M215.546 49.36l-.137.206-.133.21c.325.473.697 1.041 1.086 1.692l.096-.17a.476.476 0 01.037-.059c.041-.078.087-.156.128-.234a29.541 29.541 0 00-1.077-1.645zm1.499-2.182c-.05.064-.096.129-.142.193.335.417.674.889 1.031 1.42.046-.073.092-.142.138-.21.018-.028.032-.05.05-.074.028-.045.06-.087.087-.128a20.093 20.093 0 00-1.022-1.389c-.046.06-.096.124-.142.188z"
          fill="#000"
        />
        <path
          opacity={0.07}
          d="M215.546 49.361l-.137.207c.325.467.692 1.026 1.086 1.672.041-.077.087-.155.129-.233a30.05 30.05 0 00-1.078-1.646zm1.357-1.989c.335.417.674.89 1.031 1.421.046-.073.092-.142.138-.21a21.66 21.66 0 00-1.027-1.403c-.05.064-.096.128-.142.192z"
          fill="#000"
        />
      </g>
      <defs>
        <filter
          id="filter0_d_1161_6599"
          x={58}
          y={104.078}
          width={156.614}
          height={83.8418}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix in="SourceAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
          <feOffset dy={12} />
          <feGaussianBlur stdDeviation={5} />
          <feColorMatrix values="0 0 0 0 0.226735 0 0 0 0 0.437054 0 0 0 0 0.687819 0 0 0 0.15 0" />
          <feBlend in2="BackgroundImageFix" result="effect1_dropShadow_1161_6599" />
          <feBlend in="SourceGraphic" in2="effect1_dropShadow_1161_6599" result="shape" />
        </filter>
        <filter
          id="filter1_dd_1161_6599"
          x={202.614}
          y={114}
          width={52}
          height={59}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix in="SourceAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
          <feOffset dy={12} />
          <feGaussianBlur stdDeviation={5} />
          <feColorMatrix values="0 0 0 0 0.525 0 0 0 0 0.525 0 0 0 0 0.525 0 0 0 0.2 0" />
          <feBlend in2="BackgroundImageFix" result="effect1_dropShadow_1161_6599" />
          <feColorMatrix in="SourceAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
          <feOffset dy={5} />
          <feGaussianBlur stdDeviation={5} />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0" />
          <feBlend in2="effect1_dropShadow_1161_6599" result="effect2_dropShadow_1161_6599" />
          <feBlend in="SourceGraphic" in2="effect2_dropShadow_1161_6599" result="shape" />
        </filter>
        <filter
          id="filter2_d_1161_6599"
          x={45}
          y={20.1484}
          width={156.614}
          height={83.8418}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix in="SourceAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
          <feOffset dy={12} />
          <feGaussianBlur stdDeviation={5} />
          <feColorMatrix values="0 0 0 0 0.226735 0 0 0 0 0.437054 0 0 0 0 0.687819 0 0 0 0.15 0" />
          <feBlend in2="BackgroundImageFix" result="effect1_dropShadow_1161_6599" />
          <feBlend in="SourceGraphic" in2="effect1_dropShadow_1161_6599" result="shape" />
        </filter>
        <filter
          id="filter3_dd_1161_6599"
          x={189.614}
          y={30.0703}
          width={52}
          height={59}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix in="SourceAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
          <feOffset dy={12} />
          <feGaussianBlur stdDeviation={5} />
          <feColorMatrix values="0 0 0 0 0.525 0 0 0 0 0.525 0 0 0 0 0.525 0 0 0 0.2 0" />
          <feBlend in2="BackgroundImageFix" result="effect1_dropShadow_1161_6599" />
          <feColorMatrix in="SourceAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
          <feOffset dy={5} />
          <feGaussianBlur stdDeviation={5} />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0" />
          <feBlend in2="effect1_dropShadow_1161_6599" result="effect2_dropShadow_1161_6599" />
          <feBlend in="SourceGraphic" in2="effect2_dropShadow_1161_6599" result="shape" />
        </filter>
        <linearGradient
          id="paint0_linear_1161_6599"
          x1={238.004}
          y1={135.343}
          x2={224.817}
          y2={135.343}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#0081FB" />
          <stop offset={0.995} stopColor="#0064E1" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_1161_6599"
          x1={222.114}
          y1={139.065}
          x2={222.114}
          y2={129.963}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#0081FB" />
          <stop offset={0.995} stopColor="#0064E1" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_1161_6599"
          x1={225.004}
          y1={51.4134}
          x2={211.817}
          y2={51.4134}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#0081FB" />
          <stop offset={0.995} stopColor="#0064E1" />
        </linearGradient>
        <linearGradient
          id="paint3_linear_1161_6599"
          x1={209.114}
          y1={55.1351}
          x2={209.114}
          y2={46.0335}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#0081FB" />
          <stop offset={0.995} stopColor="#0064E1" />
        </linearGradient>
        <clipPath id="clip0_1161_6599">
          <path fill="#fff" transform="translate(218.614 124)" d="M0 0H22V22H0z" />
        </clipPath>
        <clipPath id="clip1_1161_6599">
          <path fill="#fff" transform="translate(205.614 40.07)" d="M0 0H22V22H0z" />
        </clipPath>
      </defs>
    </svg>
  )
}

export default ConvertionReportSVG
